import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withModifiers as _withModifiers, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "step-bar",
  id: "stepBar"
};
const _hoisted_2 = {
  class: "step-item"
};
const _hoisted_3 = {
  class: "step-item"
};
const _hoisted_4 = {
  class: "mbody",
  id: "mbody"
};
const _hoisted_5 = {
  class: "sf"
};
const _hoisted_6 = {
  class: "sf-row"
};
const _hoisted_7 = {
  class: "mf-count"
};
const _hoisted_8 = {
  class: "sf-row"
};
const _hoisted_9 = {
  class: "track-pills",
  id: "trackPills"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "sf-row"
};
const _hoisted_12 = {
  class: "mf-count"
};
const _hoisted_13 = {
  id: "descCount"
};
const _hoisted_14 = {
  class: "sf-row",
  style: {
    "margin-bottom": "0"
  }
};
const _hoisted_15 = {
  id: "step2"
};
const _hoisted_16 = {
  class: "platform-rec"
};
const _hoisted_17 = {
  class: "proj-list"
};
const _hoisted_18 = {
  class: "proj-list",
  style: {
    "max-height": "186px",
    "overflow-y": "auto"
  }
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
  class: "pc-emoji"
};
const _hoisted_21 = ["src"];
const _hoisted_22 = {
  key: 1
};
const _hoisted_23 = {
  class: "pc-info"
};
const _hoisted_24 = {
  class: "pc-name"
};
const _hoisted_25 = {
  class: "pc-meta"
};
const _hoisted_26 = {
  class: "pc-radio"
};
const _hoisted_27 = {
  class: "zip-body",
  id: "zipBody"
};
const _hoisted_28 = {
  class: "zip-body-inner"
};
const _hoisted_29 = {
  style: {
    "margin-top": "12px"
  }
};
const _hoisted_30 = ["accept"];
const _hoisted_31 = {
  id: "zipFileRow"
};
const _hoisted_32 = {
  class: "uf-info"
};
const _hoisted_33 = {
  class: "uf-name",
  id: "zipFileName"
};
const _hoisted_34 = {
  class: "uf-meta",
  id: "zipFileMeta"
};
const _hoisted_35 = {
  key: 0
};
const _hoisted_36 = ["onClick"];
const _hoisted_37 = {
  id: "stepSuccess"
};
const _hoisted_38 = {
  class: "success-screen"
};
const _hoisted_39 = {
  class: "ss-sub"
};
const _hoisted_40 = {
  class: "ss-detail"
};
const _hoisted_41 = {
  class: "ssd-row"
};
const _hoisted_42 = {
  class: "ssd-val",
  id: "ssWorkName"
};
const _hoisted_43 = {
  class: "ssd-row"
};
const _hoisted_44 = {
  class: "ssd-val",
  id: "ssTrack"
};
const _hoisted_45 = {
  class: "ssd-row"
};
const _hoisted_46 = {
  class: "ssd-val"
};
const _hoisted_47 = {
  class: "mfoot",
  style: {
    "justify-content": "space-between"
  }
};
const _hoisted_48 = {
  class: "mf-left",
  id: "mfLeft"
};
const _hoisted_49 = {
  class: "mf-btns"
};
const _hoisted_50 = ["disabled"];
import { ref, computed, inject, watch } from "vue";
import dayjs from "dayjs";
// import { useMediaQuery } from "@vueuse/core";
import request, { uploadFile2CDN } from "@/utils/request";
import toast from "@/utils/toast";
import { isLogin } from "@/utils/auth";
import { toCreateAigc } from "@/utils";
import CompetitionDialog from "@/components/CompetitionDialog.vue";
// import CompetitionMobilePopup from "@/components/CompetitionMobilePopup.vue";
import loading from "@/utils/loading";
export default {
  __name: 'CompetitionSubmitDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    },
    work: {
      type: Object,
      default: () => ({})
    },
    goSection: {
      type: Function,
      default: () => {}
    }
  },
  emits: ["update:modelValue", "close", "submit"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;

    // 使用计算属性处理 v-model
    const visible = computed({
      get: () => props.modelValue,
      set: value => emit("update:modelValue", value)
    });

    // const isMobile = useMediaQuery("(max-width: 767px)");

    const isAdd = computed(() => !props.work.work_id);
    const close = () => {
      formModal.value = defaultFormModal();
      workFiles.value = [];
      emit("update:modelValue", false);
      emit("close");
    };
    const showMyWorks = () => {
      close();
      props.goSection("submit");
    };
    const currentStep = ref(1);
    const showZip = ref(true);
    const agreement_accepted = ref(false);
    const display_authorized = ref(false);
    const originality_checked = ref(false);
    const pdfReaded = ref(false);
    const defaultFormModal = () => ({
      work_name: "",
      track: "东方奇幻",
      description: "",
      highlights: "",
      signature: "",
      file_name: "",
      file_path: "",
      projects: [],
      submission_no: ""
    });
    const formModal = ref(defaultFormModal());
    const workFiles = ref([]);

    // aigc平台已创作的作品
    const aigcWorks = ref([]);
    const getAigcWorks = async () => {
      try {
        const res = await request.get("/api/v3/project/list?offset=0");
        if (res.code === 200) {
          aigcWorks.value = res.data.items || [];
        }
      } catch (error) {
        console.error(error);
      }
    };
    const checkProjectSelected = project => !!formModal.value.projects?.map(p => p.project_id).includes(project.id);
    const handleToggleProject = project => {
      if (checkProjectSelected(project)) {
        formModal.value.projects = formModal.value.projects.filter(p => p.project_id !== project.id);
      } else {
        formModal.value.projects.push({
          project_id: project.id,
          name: project.name
        });
      }
    };

    // 注入父组件的登录触发方法
    const triggerLogin = inject("triggerLogin", () => {});
    watch(() => props.modelValue, newValue => {
      if (newValue) {
        if (!isLogin()) {
          // 如果未登录，则调用父组件的方法展示登录弹窗
          triggerLogin();
          close();
        }
        currentStep.value = 1;
        if (props.work?.work_id) {
          formModal.value = {
            ...props.work,
            work_name: props.work.title || "",
            description: props.work.summary || ""
          };
          workFiles.value = [...(props.work.files || [])];
        }
        getAigcWorks();
      }
    });
    const videoExtensions = [".mp4", ".mov", ".avi", ".mkv", ".flv", ".wmv", ".webm"];
    const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"]; // Added image extension
    const zipExtensions = [".zip"];
    const allExtensions = [...videoExtensions, ...imageExtensions, ...zipExtensions];
    const validateWorkFile = file => {
      const fileName = file.name.toLowerCase();
      const isVideo = videoExtensions.some(ext => fileName.endsWith(ext));
      const isImage = imageExtensions.some(ext => fileName.endsWith(ext)); // Added image check
      const isZip = zipExtensions.some(ext => fileName.endsWith(ext));
      if (!isVideo && !isImage && !isZip) {
        // Updated condition
        toast("仅支持上传视频、图片和 .zip 格式文件", 5000, "warning");
        return false;
      }

      // Check file size (2GB limit)
      const maxSize = 2 * 1024 * 1024 * 1024;
      if (file.size > maxSize) {
        toast("文件大小不能超过 2GB", 5000, "warning");
        return false;
      }
      return true;
    };
    const handleZipDrop = event => {
      // console.log("handleZipDrop:", event, event.dataTransfer.files);
      const file = event.dataTransfer.files[0];
      if (file && validateWorkFile(file)) {
        handleUpload(file);
      }
    };
    const handleZipChange = event => {
      // console.log("handleZipChange:", event, event.target.files);
      const file = event.target.files[0];
      if (file && validateWorkFile(file)) {
        handleUpload(file);
      }
    };
    const handleUpload = async file => {
      loading.show("上传中，请稍后");
      try {
        const uploadData = await uploadFile2CDN(file);
        toast("上传成功", 3000, "success");
        workFiles.value.push({
          ...uploadData,
          name: file.name,
          type: file.type,
          size: file.size
        });
      } catch (err) {
        workFiles.value = workFiles.value.filter(f => f.name !== file.name);
        console.error(err);
        toast("上传失败，请稍后重试", 5000, "error");
      } finally {
        loading.hide();
      }
    };
    const handleFileRemove = async index => {
      workFiles.value.splice(index, 1);
    };
    const computeFizeSize = size => {
      if (size < 1024 * 1024) return (size / 1024).toFixed(2) + " KB";
      return (size / 1024 / 1024).toFixed(2) + " MB";
    };

    // function checkPdfScroll(el) {
    //   if (pdfReaded.value) return;

    //   if (el.scrollHeight - el.scrollTop - el.clientHeight < 40) {
    //     const h = document.getElementById("pdfHint");
    //     if (h) {
    //       h.textContent = "✓ 已阅读完整协议";
    //       h.className = "pdf-scroll-hint read";
    //       pdfReaded.value = true;
    //     }
    //   }
    // }

    const goPrevStep = () => {
      currentStep.value--;
    };
    const canNext = computed(() => {
      const canStep1 = formModal.value.work_name?.trim() !== "" && formModal.value.description?.trim() !== "";
      const canStep2 = workFiles.value.length > 0;
      const canStep3 = agreement_accepted.value && display_authorized.value && originality_checked.value && pdfReaded.value && formModal.value.signature?.trim() !== "";
      if (currentStep.value === 1) return canStep1;else if (currentStep.value === 2) return canStep1 && canStep2;
      return canStep1 && canStep2 && canStep3;
    });
    const goNextStep = () => {
      // console.log(formModal.value);
      if (currentStep.value === 2) {
        submit();
      }
      if (currentStep.value < 2) {
        currentStep.value++;
      }
    };
    const submit = async () => {
      try {
        const params = {
          ...formModal.value,
          files: workFiles.value.map(file => ({
            name: file.name,
            type: file.type,
            size: file.size,
            path: file.cosPath
          }))
        };
        const res = await request.post("/contest/user/work/submit?contest_id=" + props.data.contest_id, params);
        if (res.code === 200) {
          if (isAdd.value) {
            currentStep.value++;
            formModal.value.submission_no = res.data.submission_no;
          } else {
            close();
          }
          toast("提交成功");
          emit("submit", res.data);
        } else {
          toast(res.msg || "提交失败");
        }
      } catch (error) {
        console.error("提交失败:", error);
        toast("提交失败，请稍后重试");
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_resolveDynamicComponent(CompetitionDialog), {
        modelValue: visible.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => visible.value = $event),
        title: "提交参赛作品",
        subtitle: __props.data.title,
        width: 640,
        onClose: close
      }, {
        footer: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, "步骤 " + _toDisplayString(currentStep.value) + " / 2 · 填写作品基本信息", 1), _createElementVNode("div", _hoisted_49, [_createElementVNode("button", {
          class: "mf-back",
          onClick: close
        }, "关闭"), _withDirectives(_createElementVNode("button", {
          class: "mf-back",
          onClick: goPrevStep
        }, "← 上一步", 512), [[_vShow, currentStep.value > 1]]), currentStep.value > 1 && !isAdd.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [!__props.readonly ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "mf-next grn",
          onClick: submit
        }, "保存修改")) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: _normalizeClass(["mf-next", {
            grn: currentStep.value > 1
          }]),
          id: "mfNext",
          disabled: !canNext.value,
          onClick: goNextStep
        }, _toDisplayString(currentStep.value < 2 ? "下一步 →" : "✓ 提交作品"), 11, _hoisted_50))])], 512), [[_vShow, currentStep.value <= 2]])]),
        default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
          class: _normalizeClass(["step-num", {
            active: currentStep.value === 1,
            done: currentStep.value > 1,
            pending: currentStep.value < 1
          }])
        }, "1", 2), _createElementVNode("div", {
          class: _normalizeClass(["step-label", {
            active: currentStep.value === 1,
            done: currentStep.value > 1,
            pending: currentStep.value < 1
          }])
        }, "作品信息", 2)]), _createElementVNode("div", {
          class: _normalizeClass(["step-line", {
            done: currentStep.value > 1
          }])
        }, null, 2), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
          class: _normalizeClass(["step-num", {
            active: currentStep.value === 2,
            done: currentStep.value > 2,
            pending: currentStep.value < 2
          }])
        }, "2", 2), _createElementVNode("div", {
          class: _normalizeClass(["step-label", {
            active: currentStep.value === 2,
            done: currentStep.value > 2,
            pending: currentStep.value < 2
          }])
        }, "内容上传", 2)])], 512), [[_vShow, currentStep.value <= 2]]), _createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("form", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_cache[6] || (_cache[6] = _createElementVNode("div", {
          class: "sf-lbl"
        }, [_createElementVNode("span", {
          class: "req"
        }, "*"), _createTextVNode(" 作品名称")], -1)), _withDirectives(_createElementVNode("input", {
          class: "sf-inp",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formModal.value.work_name = $event),
          placeholder: "为你的参赛作品取一个响亮的名字",
          maxlength: "40"
        }, null, 512), [[_vModelText, formModal.value.work_name]]), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(formModal.value.work_name.length), 1), _cache[5] || (_cache[5] = _createTextVNode(" /40 ", -1))])]), _createElementVNode("div", _hoisted_8, [_cache[7] || (_cache[7] = _createElementVNode("div", {
          class: "sf-lbl"
        }, [_createElementVNode("span", {
          class: "req"
        }, "*"), _createTextVNode(" 参赛赛道")], -1)), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data.submission?.tracks || [], item => {
          return _openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["tpill", {
              sel: formModal.value.track === item
            }]),
            key: item,
            onClick: $event => formModal.value.track = item
          }, _toDisplayString(item), 11, _hoisted_10);
        }), 128))])]), _createElementVNode("div", _hoisted_11, [_cache[9] || (_cache[9] = _createElementVNode("div", {
          class: "sf-lbl"
        }, [_createElementVNode("span", {
          class: "req"
        }, "*"), _createTextVNode(" 作品描述")], -1)), _withDirectives(_createElementVNode("textarea", {
          class: "sf-ta",
          id: "workDesc",
          placeholder: "向评委介绍你的作品：故事背景、创作灵感、AI工具的运用方式… 建议100–300字",
          rows: "5",
          maxlength: "500",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formModal.value.description = $event)
        }, null, 512), [[_vModelText, formModal.value.description]]), _createElementVNode("div", _hoisted_12, [_createElementVNode("span", _hoisted_13, _toDisplayString(formModal.value.description.length), 1), _cache[8] || (_cache[8] = _createTextVNode(" /500 ", -1))])]), _createElementVNode("div", _hoisted_14, [_cache[10] || (_cache[10] = _createElementVNode("div", {
          class: "sf-lbl"
        }, "创作亮点（选填）", -1)), _withDirectives(_createElementVNode("textarea", {
          class: "sf-ta",
          placeholder: "有哪些特别的技术尝试或创作突破？例如「使用了9宫格批量生图配合手动分镜调整」",
          rows: "2",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formModal.value.highlights = $event)
        }, null, 512), [[_vModelText, formModal.value.highlights]])])], 512), [[_vShow, currentStep.value === 1]]), _withDirectives(_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_cache[12] || (_cache[12] = _createElementVNode("div", {
          class: "pr-title"
        }, " 从芒果灵创项目提交 ", -1)), _cache[13] || (_cache[13] = _createElementVNode("div", {
          class: "pr-sub"
        }, [_createTextVNode("系统将自动核验生产记录，"), _createElementVNode("strong", null, "无需上传文件"), _createTextVNode("，且可享受参赛加速包额外点数支持。平台提交作品优先进入评审队列。")], -1)), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aigcWorks.value, item => {
          return _openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["proj-card", {
              sel: checkProjectSelected(item)
            }]),
            key: item.id,
            onClick: $event => handleToggleProject(item)
          }, [_createElementVNode("div", _hoisted_20, [item.thumbPath ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: item.thumbPath,
            style: {
              "width": "24px",
              "height": "24px",
              "object-fit": "cover"
            }
          }, null, 8, _hoisted_21)) : (_openBlock(), _createElementBlock("span", _hoisted_22, "🌫"))]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_25, [_createElementVNode("span", null, _toDisplayString(_unref(dayjs)(item.startAt * 1000).format("YYYY.MM.DD")) + " - " + _toDisplayString(_unref(dayjs)(item.endAt * 1000).format("YYYY.MM.DD")), 1)])]), _createElementVNode("div", _hoisted_26, _toDisplayString(checkProjectSelected(item) ? "✓" : ""), 1)], 10, _hoisted_19);
        }), 128))]), _createElementVNode("div", {
          class: "proj-new",
          onClick: _cache[3] || (_cache[3] = (...args) => _unref(toCreateAigc) && _unref(toCreateAigc)(...args))
        }, [...(_cache[11] || (_cache[11] = [_createElementVNode("div", {
          class: "proj-new-icon"
        }, "＋", -1), _createElementVNode("div", {
          class: "proj-new-text"
        }, "新建参赛项目，前往创作台", -1)]))])])]), _cache[22] || (_cache[22] = _createElementVNode("div", {
          class: "or-divider"
        }, "选择上传文件", -1)), _createElementVNode("div", {
          class: _normalizeClass(["zip-section", {
            open: showZip.value
          }]),
          id: "zipSection"
        }, [_cache[21] || (_cache[21] = _createElementVNode("div", {
          class: "zip-toggle"
        }, [_createElementVNode("div", {
          class: "zip-toggle-left"
        }, [_createElementVNode("div", {
          class: "zip-icon"
        }, "📦"), _createElementVNode("div", null, [_createElementVNode("div", {
          class: "zip-title"
        }, "上传参赛作品文件"), _createElementVNode("div", {
          class: "zip-sub"
        }, "可上传视频 + 素材压缩包，具体要求请参见赛事详情")])])], -1)), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_cache[20] || (_cache[20] = _createElementVNode("div", {
          class: "zip-warn"
        }, [_createElementVNode("span", null, "⚠️"), _createElementVNode("span", null, "外部上传的作品需人工审核生产来源，审核周期 1–3 个工作日。")], -1)), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", {
          class: "upload-zone",
          id: "zipZone",
          ondragover: "event.preventDefault();this.classList.add('drag')",
          ondragleave: "this.classList.remove('drag')",
          onclick: "document.getElementById('zipInput').click()",
          onDrop: _withModifiers(handleZipDrop, ["prevent"])
        }, [_cache[14] || (_cache[14] = _createElementVNode("div", {
          class: "uz-icon"
        }, "📦", -1)), _cache[15] || (_cache[15] = _createElementVNode("div", {
          class: "uz-title"
        }, "拖入或点击上传参赛作品文件", -1)), _cache[16] || (_cache[16] = _createElementVNode("div", {
          class: "uz-desc"
        }, "限制：单文件最大 2GB ｜ 支持：.mp4, .mkv, .zip, .jpg, .png 等格式", -1)), _cache[17] || (_cache[17] = _createElementVNode("div", {
          class: "uz-btn"
        }, "选择文件", -1)), _createElementVNode("input", {
          type: "file",
          id: "zipInput",
          accept: allExtensions.join(','),
          style: {
            "display": "none"
          },
          onChange: handleZipChange
        }, null, 40, _hoisted_30)], 32), _withDirectives(_createElementVNode("div", _hoisted_31, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workFiles.value, (file, i) => {
          return _openBlock(), _createElementBlock("div", {
            class: "uploaded-file",
            key: file.name
          }, [_cache[19] || (_cache[19] = _createElementVNode("div", {
            class: "uf-icon"
          }, "📦", -1)), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, _toDisplayString(file.name), 1), _createElementVNode("div", _hoisted_34, [file.size != null ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(computeFizeSize(file.size)) + " ·", 1)) : _createCommentVNode("", true), _cache[18] || (_cache[18] = _createTextVNode(" ✓ 校验通过 ", -1))])]), _createElementVNode("div", {
            class: "uf-remove",
            onClick: $event => handleFileRemove(i)
          }, "✕", 8, _hoisted_36)]);
        }), 128))], 512), [[_vShow, workFiles.value.length > 0]])])])])], 2)], 512), [[_vShow, currentStep.value === 2]]), _withDirectives(_createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_cache[28] || (_cache[28] = _createElementVNode("div", {
          class: "ss-icon"
        }, "🎉", -1)), _cache[29] || (_cache[29] = _createElementVNode("div", {
          class: "ss-title"
        }, "作品提交成功！", -1)), _createElementVNode("div", _hoisted_39, "您的参赛作品已提交至" + _toDisplayString(__props.data?.title) + "，评审团将于 7月1日 开始审阅。祝您获奖！", 1), _createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_cache[23] || (_cache[23] = _createElementVNode("span", {
          class: "ssd-key"
        }, "作品名称", -1)), _createElementVNode("span", _hoisted_42, _toDisplayString(formModal.value.work_name), 1)]), _createElementVNode("div", _hoisted_43, [_cache[24] || (_cache[24] = _createElementVNode("span", {
          class: "ssd-key"
        }, "参赛赛道", -1)), _createElementVNode("span", _hoisted_44, _toDisplayString(formModal.value.track), 1)]), _cache[26] || (_cache[26] = _createElementVNode("div", {
          class: "ssd-row"
        }, [_createElementVNode("span", {
          class: "ssd-key"
        }, "来源"), _createElementVNode("span", {
          class: "ssd-val",
          id: "ssSrc"
        }, "芒果灵创")], -1)), _createElementVNode("div", _hoisted_45, [_cache[25] || (_cache[25] = _createElementVNode("span", {
          class: "ssd-key"
        }, "提交编号", -1)), _createElementVNode("span", _hoisted_46, _toDisplayString(formModal.value.submission_no), 1)]), _cache[27] || (_cache[27] = _createElementVNode("div", {
          class: "ssd-row"
        }, [_createElementVNode("span", {
          class: "ssd-key"
        }, "协议签署"), _createElementVNode("span", {
          class: "ssd-val",
          style: {
            "color": "var(--grn)"
          }
        }, "✓ 已完成")], -1))]), _createElementVNode("div", {
          class: "ss-btns"
        }, [_createElementVNode("div", {
          class: "ssb ghost",
          onClick: close
        }, "关闭"), _createElementVNode("div", {
          class: "ssb ora",
          onClick: showMyWorks
        }, "查看我的作品")])])], 512), [[_vShow, currentStep.value > 2]])])]),
        _: 1
      }, 40, ["modelValue", "subtitle"]);
    };
  }
};